export default {
  // 1 个人账号: 注册 / 登录 / 修改密码
  //   1.1 注册
  ADMIN_DUP_USERNAME: 'このユーザー名は既に存在します',
  // REGISTER_DUP_LOGIN_ID: '交易系统用户名已存在',
  // REGISTER_USERNAME_WRONG_FORMAT_HAS_SPACE: '注册用户名不能包含空格',
  //   1.2 登录
  LOGIN_FAILED: 'ログインに失敗しました。ユーザー名またはパスワードが正しくありません',
  LOGIN_NOT_ENABLED: 'アカウントは無効になっています',
  LOGIN_LOCKED: 'アカウントはロックされています',
  DOB_IS_BEFORE_TODAY: '生年月日は現在の日付よりも前である必要があります',
  BANK_CARD_DUP_NUMBER: 'この銀行カード番号は既に存在します',
  ID_CARD_ID_WRONG_FORMAT: '身分証明書番号の形式が正しくありません',
  MOBILE_WRONG_FORMAT: '携帯番号の形式が正しくありません',
  REGISTER_DUP_MOBILE: 'この携帯番号は既に登録されています',
  REGISTER_DUP_USERNAME: 'このユーザー名は既に登録されています',
  USERNAME_WRONG_FORMAT: 'ユーザー名の形式が正しくありません',
  //   1.3 密码
  PASSWORD_NULL: 'パスワードは空にできません',
  PASSWORD_WRONG: 'パスワードが間違っています',
  PASSWORD_WRONG_FORMAT: 'パスワードは6〜16文字で、スペースを含んではいけません',
  PASSWORD_WRONG_TIME_LEFT: 'パスワードが間違っています。残り試行回数: {timeLeft}回',
  PASSWORD_CONFIRM_NOT_MATCH: 'パスワード確認が一致しません',
  PASSWORD_WRONG_AND_LOCK: 'パスワードが{failedAttempt}回連続で間違って入力され、アカウントがロックされました',
  CONFIRM_PASSWORD_NOT_MATCH: 'パスワード確認が一致しません',
  // 2. Jwt Token
  JWT_INVALID_TOKEN: 'ログインが期限切れです。もう一度ログインしてください',
  JWT_VERSION_NOT_MATCHED: 'バージョンが一致しません',
  // 3. 权限
  PERMISSION_DENY: 'アクセス権限がありません',
  PERMISSION_DENY_ADMIN_ONLY: 'この操作はシステム管理者のみが実行できます',
  PERMISSION_DENY_ADMIN_OR_IT_ONLY: 'この操作はシステム管理者または機関管理者のみが実行できます',
  // 4. 验证码
  SMS_VERIFY_CODE_NOT_MATCH: '検証コードが一致しません', // 携帯
  CAPTCHA_VERIFY_CODE_NOT_MATCH: '検証コードが一致しません', // Captcha
  // 5. 参数校验
  INVALID_ARGUMENT: '無効なパラメーター',
  INVALID_REGISTER: '登録者が無効です',
  INVALID_ARGUMENT_NULL_POINT: '無効なパラメーター：パラメーターは空にできません',
  //   5.1 基础相关
  INVALID_ARGUMENT_BAD_AGENT: 'エージェントが無効です',
  INVALID_ARGUMENT_CUSTOMER_AUTH_NOT_EXIST: '顧客認証情報が存在しません',
  INVALID_ARGUMENT_MIN_DEPOSIT: '最小入金額：{minDeposit}米ドル（または同等の通貨金額）を超える必要があります',
  INVALID_ARGUMENT_MAX_DEPOSIT: '最大入金額：{maxDeposit}米ドル（または同等の通貨金額）を超えることはできません',
  INVALID_ARGUMENT_MIN_WITHDRAWAL: '最小出金額：{minWithdrawal}米ドル（または同等の通貨金額）を超える必要があります',
  INVALID_ARGUMENT_MAX_WITHDRAWAL: '最大出金額：{maxWithdrawal}米ドル（または同等の通貨金額）を超えることはできません',
  INVALID_ARGUMENT_MORE_THAN_2_SCALES: '小数点以下の桁数は2桁を超えることはできません',
  INVALID_ARGUMENT_RESOURCE_SAVE: 'リソースの保存パラメーターが無効です',
  INVALID_ARGUMENT_NULL_PASSWORD: 'パスワードは空にできません',
  INVALID_ARGUMENT_CONFIRM_PASSWORD: 'パスワード確認が一致しません',
  INVALID_ARGUMENT_CAN_NOT_DELETE_FOR_VERIFIED: '認証済みのデータは削除できません',
  INVALID_ARGUMENT_ENTER_BANK_NUM: '銀行カード番号を入力してください',
  INVALID_ARGUMENT_IT_DUP_ID: 'この機関IDは既に存在します',
  INVALID_ARGUMENT_IT_DUP_APP_KEY: 'ユーザー名はすでに使用されています，別のユーザー名を選択してください',
  INVALID_ARGUMENT_CONFIG_BANK_NOT_NULL: 'BANK 情報を空にすることはできません。バンク カード管理ページに移動して、BANK 情報を追加してください。',
  //   5.2 货币相关
  INVALID_ARGUMENT_CURRENCY_BASE_QUOTE_CAN_NOT_BE_THE_SAME: '2つの通貨は同じであってはいけません',
  INVALID_ARGUMENT_FX_RATE_CAN_BE_NULL: '為替レートは空にできません',
  INVALID_ARGUMENT_FX_RATE_MUST_BE_POSITIVE: '為替レートはゼロまたは負の数にすることはできません',
  INVALID_ARGUMENT_CURRENCY_DUP_CURRENCY_PAIR: '同じ通貨ペアは既に存在します',
  INVALID_ARGUMENT_CURRENCY_AMOUNT_NOT_MATCH: '通貨レート変換額が誤っています',
  INVALID_ARGUMENT_CURRENCY_FX_RATE_NOT_FOUND: '通貨ペアに対応する為替レートが見つかりません',
  INVALID_ARGUMENT_CURRENCY_FX_RATE_TEMPLATE_NOT_FOUND: '為替レートテンプレートが見つかりません',
  INVALID_ARGUMENT_CURRENCY_INVALID_FOR_THIS_BANK: 'この銀行ではこの通貨は無効です',
  INVALID_ARGUMENT_CURRENCY_INVALID_FOR_THIS_RECEIVE_METHOD: 'この入金方法ではこの通貨は無効です',
  //   5.3 用户相关
  INVALID_ARGUMENT_LOGIN_AUTH_BY_GOOGLE: 'メールはすでにGOOGLEによって認証されています、GOOGLEの認証でログインしてください',
  INVALID_ARGUMENT_LOGIN_AUTH_BY_FACEBOOK: 'メールはすでにFACEBOOKによって認証されています、FACEBOOKの認証でログインしてください',
  INVALID_ARGUMENT_LOGIN_AUTH_BY_APPLE: 'メールはすでにAPPLEによって認証されています、APPLEの認証でログインしてください',
  INVALID_ARGUMENT_LOGIN_AUTH_BY_PASSWORD: 'メールはパスワードで認証されています、パスワードでログインしてください',
  INVALID_ARGUMENT_CUSTOMER_NOT_EXIST: '顧客情報が存在しません',
  INVALID_ARGUMENT_FORMAT_PASSWORD: '大文字、小文字、数字を少なくとも1つ含む、8〜32文字のパスワード形式を使用してください',
  INVALID_ARGUMENT_EMAIL_CODE_NOT_EXIST: 'リンクが存在しません',
  INVALID_ARGUMENT_EMAIL_CODE_REPEAT: 'リンクは無効です',
  INVALID_ARGUMENT_EMAIL_CODE_TIMEOUT: 'リンクの有効期限が切れました',
  INVALID_ARGUMENT_CUSTOMER_FORMAT: 'ユーザー名はメールアドレスである必要があります',
  INVALID_ARGUMENT_CUSTOMER_DUP_USERNAME: 'ユーザー名は既に存在します',
  INVALID_ARGUMENT_CUSTOMER_DUP_MOBILE: '携帯番号は既に存在します',
  INVALID_ARGUMENT_CUSTOMER_NOT_VERIFIED: '顧客情報は未認証です',
  INVALID_ARGUMENT_CUSTOMER_ACCOUNT_NOT_ACTIVATED: '顧客取引アカウントはアクティブ化されていません',
  CUSTOMER_VERIFY_FLOW_NOT_FOUND: '顧客検証フローが存在しません',
  CUSTOMER_WITHDRAWAL_FLOW_NOT_FOUND: '顧客出金フローが存在しません',
  INVALID_ARGUMENT_CUSTOMER_ID_EXPIRE_LIMIT: '身分情報の有効期限は最低{days}日間を残しておく必要があります',
  //   5.4 业务流程相关
  INVALID_ARGUMENT_UNABLE_TO_LOCK_WITHDRAWAL_AMOUNT: '金額をロックできません。もう一度試してみてください',
  INVALID_ARGUMENT_PROCESS_SUBMIT_ILLEGAL_STATUS: 'すでに提出済みです',
  INVALID_ARGUMENT_PASSWORD_TIME_MISMATCH: 'パスワードの時刻が一致しません',
  INVALID_ARGUMENT_PROCESS_RETRACT_ILLEGAL_STATUS: '取り消すことはできません',
  INVALID_ARGUMENT_PROCESS_RETRACT_ILLEGAL_PROCESSED:
    '処理ステータスが正しくありません：処理ステータスが未処理の場合のみ取り消し操作ができます（データが変更されている可能性があるため、データを再取得してからもう一度試してみてください）',
  INVALID_ARGUMENT_PROCESS_APPROVAL_ILLEGAL_STATUS:
    '承認ステータスが正しくありません：承認ステータスが提出時にのみ拒否または承認できます（データが変更されている可能性があるため、データを再取得してからもう一度試してみてください）',
  INVALID_ARGUMENT_PROCESS_APPROVAL_ILLEGAL_PROCESSED:
    '処理ステータスが正しくありません：処理ステータスが未処理の場合のみ拒否または承認できます（データが変更されている可能性があるため、データを再取得してからもう一度試してみてください）',
  INVALID_ARGUMENT_PROCESS_APPROVED_FLOW_ILLEGAL_STATUS:
    '承認ステータスが正しくありません：承認ステータスが通過の場合のみ処理操作を完了できます（データが変更されている可能性があるため、データを再取得してからもう一度試してみてください）',
  INVALID_ARGUMENT_PROCESS_APPROVED_FLOW_ILLEGAL_PROCESSED:
    '処理ステータスが正しくありません：処理ステータスが未処理の場合のみ処理操作を完了できます（データが変更されている可能性があるため、データを再取得してからもう一度試してみてください）',
  INVALID_ARGUMENT_PROCESS_REJECT_FLOW_ILLEGAL_STATUS:
    '承認ステータスが正しくありません：承認ステータスが拒否の場合のみ処理操作を完了できます（データが変更されている可能性があるため、データを再取得してからもう一度試してみてください）',
  INVALID_ARGUMENT_PROCESS_ILLEGAL_STATUS: 'ステータスエラー',
  //   5.5 KRAMPUS API相关
  INVALID_ARGUMENT_KRAMPUS_API_DUP_LOGIN: '取引システムのユーザー名はすでに存在します',
  INVALID_ARGUMENT_KRAMPUS_API_WRONG_KEY_OR_SECRET: '取引システムのユーザー名/パスワードが正しくありません',
  INVALID_ARGUMENT_KRAMPUS_API_LOGIN_FAILED: '取引システムのログインに失敗しました',
  INVALID_ARGUMENT_KRAMPUS_API_SYNC_IT_FAILED:
    '機関情報の同期に失敗しました。IDが{itId}の取引システムが見つかりませんでした。アクセス許可を確認してください',
  INVALID_ARGUMENT_KRAMPUS_API_INVOKE_ERROR: '取引システムの呼び出しに失敗しました',
  INVALID_ARGUMENT_KRAMPUS_API_INSUFFICIENT_FUNDS: 'アカウントの残高が不足しています',
  INVALID_ARGUMENT_KRAMPUS_API_PASSWORD_IS_EMPTY: 'パスワードが空です。まずパスワードを設定してください',
  INVALID_ARGUMENT_KRAMPUS_API_TOKEN_FAILED: 'ログイン期限が切れました。再ログインしてください',
  INVALID_ARGUMENT_DEMO_KRAMPUS_API_DUP_LOGIN: 'デモ取引システムのユーザー名はすでに存在します',
  INVALID_ARGUMENT_DEMO_KRAMPUS_API_WRONG_KEY_OR_SECRET: 'デモ取引システムのユーザー名/パスワードが正しくありません',
  INVALID_ARGUMENT_DEMO_KRAMPUS_API_LOGIN_FAILED: 'デモ取引システムのログインに失敗しました',
  //   5.6 METHOD 相关
  INVALID_ARGUMENT_METHOD_BANK_USDT_INVALID: '銀行の入金通貨はUSDTではいけません',
  INVALID_ARGUMENT_METHOD_BANK_BANK_CAN_NOT_NULL: '銀行を選択してください',
  INVALID_ARGUMENT_METHOD_BANK_ACCOUNT_NAME_CAN_NOT_EMPTY: '銀行口座名は空白にできません',
  INVALID_ARGUMENT_METHOD_BANK_ACCOUNT_NUMBER_CAN_NOT_EMPTY: '銀行口座番号は空白にできません',
  //
  INVALID_ARGUMENT_METHOD_USDT_USDT_ONLY: 'USDTの入金通貨はUSDTである必要があります',
  INVALID_ARGUMENT_METHOD_USDT_AT_LEAST_ONE_IS_REQUIRED: 'アドレスまたはQRコードの少なくとも1つを入力してください',
  INVALID_ARGUMENT_METHOD_USDT_CRYPTO_NETWORK_REQUIRED: 'USDTの入金ネットワークを入力してください',
  //
  INVALID_ARGUMENT_METHOD_WECHAT_CNY_ONLY: 'WeChatの入金通貨はCNYである必要があります',
  INVALID_ARGUMENT_METHOD_REQUIRE_QR_CODE: 'この入金方法ではQRコードをアップロードする必要があります',
  //   5.7 入出金 相关
  INVALID_ARGUMENT_PAYMENT_INVOKE_ERROR: '支払APIインターフェースの呼び出しに失敗しました',
  INVALID_ARGUMENT_PAYMENT_INVOKE_PARAM_ERROR: '支払パラメータにエラーがあります',
  INVALID_ARGUMENT_PAYMENT_SAME_TYPE_PAYMENT_CHANNEL_ONLY_ONE: '同じタイプの支払いチャネルは1つしか選択できません',
  INVALID_ARGUMENT_IT_TRANSFER_CONFIG_ERROR: 'チャネル設定にエラーがあります',
  INVALID_ARGUMENT_IT_TRANSFER_CAN_NOT_BE_NULL: '機関の送金情報は空にできません',
  INVALID_ARGUMENT_IT_TRANSFER_AMOUNT_CAN_NOT_BE_NULL: '機関の送金金額は空にできません',
  INVALID_ARGUMENT_IT_TRANSFER_RECEIVE_CAN_NOT_BE_NULL: '機関の送金口座は空にできません',
  INVALID_ARGUMENT_DEPOSIT_AMOUNT_TRANSFER_AMOUNT_NOT_MATCH: '入金金額が送金金額と一致しません',
  INVALID_ARGUMENT_TRANSACTION_AMOUNT: '入出金は指定された制限額を満たしていません',
  INVALID_ARGUMENT_CONFIG_PIX_NOT_NULL: 'PIX情報は空欄にできません。銀行カードの管理ページでPIX情報を補足してください。',
  INVALID_ARGUMENT_CONFIG_IFSC_NOT_NULL: 'IFSC情報は空欄にできません。銀行カードの管理ページでIFSC情報を補足してください。',
  INVALID_ARGUMENT_DUPLICATE_WITHDRAWAL: '注文を取り消して再度現金を引き出すか、注文の確認を待って再度開始してください。',
  // 6. 操作校验
  UNSUPPORTED_OPERATION_NO_IT_RECEIVE_FOUND: 'この機関はこの通貨の入金をサポートしていません',
  // 7. email
  THIRD_PARTY_AUTH_USER_CANNOT_RESET_PASSWORD: 'サードパーティ認証ユーザはパスワードを再設定できません',
  THIRD_PARTY_AUTH_USER_CANNOT_ACTIVE_EMAIL: 'サードパーティ認証ユーザはメールを有効化する必要はありません',
  INVALID_ARGUMENT_INVALID_PROVIDERTYPE: '不正なサードパーティーログインタイプ',
  INVALID_ARGUMENT_ORIGINAL_PASSWORD_MISMATCH: '古いパスワードが一致しません',
  INVALID_ARGUMENT_NEW_PASSWORD_SAME_AS_OLD: '新しいパスワードは古いパスワードと同じにできません',
  INVALID_ARGUMENT_EXCLUSIVE_AGENT_LINK:
    '登録できません、このリンクは専用エージェントに属しており、複数回の登録が禁止されています.',
  INVALID_THIRD_PARTY_ACCOUNT_UNBINDING_FAILED: 'サードパーティアカウントのバインドの解除に失敗しました',
  INVALID_ACCOUNT_ALREADY_EXISTS_AND_LOCKED: 'アカウントはすでに存在し、ロックされています',
  INVALID_ARGUMENT_CLOSE_ACCOUNT_ERROR:
    'アカウントの解除に失敗しました、ポジションを全てクリアし、資金はゼロでなければなりません',
  INVALID_DATA_USED_CANNOT_BE_DELETED: '既に使用されたデータは削除できません',
  INVALID_ARGUMENT_INVALID_ISSUER_FORMAT: 'Issuerの形式が無効です',
  INVALID_ARGUMENT_MISSING_LOGIN_CODE: 'ログインコードが不足しています',
  INVALID_ARGUMENT_CUSTOMER_NOT_FOUND: '顧客が見つかりません',
  INVALID_ARGUMENT_MISSING_PASSWORD_VER_CLAIM: 'パスワードのバージョン宣言が不足しています',
  INVALID_ARGUMENT_PASSWORD_VER_MISMATCH: 'パスワードのバージョンが一致しません',
  INVALID_ARGUMENT_TOKEN_EXPIRED: 'トークンが期限切れです',
  INVALID_ARGUMENT_MISSING_PASSWORD_TIME_CLAIM: 'パスワード時間の請求がありません',
  INVALID_ARGUMENT_DUPLICATE_PAYMENT_CHANNEL_TYPE: '同じタイプの支払いゲートウェイは一つだけ選択できます',
  INVALID_EMAIL_CHECK_INVALID_USER: '無効なユーザー',
  INVALID_EMAIL_CHECK_USER_NOT_EXIST: 'ユーザーが存在しません',
  INVALID_EMAIL_CHECK_EMAIL_VERIFIED: 'メールアドレスはすでに確認されています',
  INVALID_EMAIL_CHECK_EMAIL_NOT_VERIFIED: 'メールアドレスは確認されていません',
  INVALID_EMAIL_CHECK_INVALID_REQUEST_PARAMETERS: '操作に失敗しました、リクエストがタイムアウトしました',
  INVALID_EMAIL_CHECK_REPEATED_REQUEST: '重複したリクエスト、後で再試行してください',
  // 99. 其他
  DATA_NOT_FOUND: 'データが見つかりません',
  STALE_VERSION: 'データが変更されました、リフレッシュして再試行してください',
  INVALID_STATE: '無効な状態、データが変更されている可能性があります',
  INVALID_VALUE: 'パラメータの内容が誤っています',
  INVALID_FORMAT: 'パラメータのフォーマットが誤っています',
  INTERNAL_ERROR: '内部エラー、管理者にお問い合わせください',
  MULTI_ARGS_TEST: 'arg1 {arg1}，arg2 {arg2}，arg3 {arg3}',
  INVALID_ARGUMENT_NOT_BLANK: '空白ではありません',

  // 第三方
  access_denied: 'アクセス拒否',
  invalid_token_response: '無効なトークン',
  authorization_request_not_found: '認証リクエストが見つかりません',

  INVALID_ARGUMENT_CUSTOMER_PHONE_FORMAT: 'ユーザー名は電話番号でなければなりません。',
  INVALID_EMAIL_CHECK_CONTACT_VERIFIED: 'アカウントは確認されました。',
  INVALID_EMAIL_CHECK_CONTACT_NOT_VERIFIED: 'アカウントは確認されていません。',
  INVALID_ARGUMENT_SMS_CODE_TIMEOUT: '認証コードは期限切れです。',
  INVALID_ARGUMENT_SMS_CODE_ERROR: '認証コードが間違っています。',
  INVALID_ARGUMENT_SMS_RATE_LIMIT: 'SMSの送信頻度を超えました。後でもう一度お試しください。',
};
